import { __awaiter } from "tslib";
import { RID } from '@sharefiledev/sfplugin-resource-id';
import { checkForPermission } from '../Common/permissions';
import { events, pendoSendTrackEvent } from '../pendo';
import { DefaultRequestListDataProvider } from '../PluginDataProvider/DefaultRequestListDataProvider';
import { PermissionPolicy, RequestListEntityType, } from '../types';
const requestListCapabilities = {
    getNavigationDetails(requestedByResourceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestListRID = getRequestListRID(requestedByResourceId);
            const navigationDetails = yield DefaultRequestListDataProvider.getRequestList(requestListRID.entityId);
            return {
                name: navigationDetails.title,
                webAppPath: `/requestlists/${navigationDetails.requestListId}`,
            };
        });
    },
};
export const TaskQueryParamName = 'task';
export const ItemDetailsTabQueryParam = 'itemTab';
const itemCapabilities = {
    getNavigationDetails(requestedByResourceId, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestListRID = getRequestListRID(requestedByResourceId);
            const itemRID = getItemRID(requestedByResourceId);
            const navigationDetails = yield DefaultRequestListDataProvider.getTask(requestListRID.entityId, requestListRID.toString(), itemRID.entityId);
            const searchParams = new URLSearchParams();
            searchParams.set(TaskQueryParamName, navigationDetails.requestListTaskId);
            if (options.targetExtensionSlotId) {
                searchParams.set(ItemDetailsTabQueryParam, options.targetExtensionSlotId);
            }
            {
                return {
                    name: navigationDetails.title,
                    webAppPath: `/requestlists/${navigationDetails.requestListId}?${searchParams.toString()}`,
                };
            }
        });
    },
};
function getRequestListRID(resourceId) {
    const rid = RID.parse(resourceId);
    const requestListRID = rid.findEntityType(RequestListEntityType.requestlist);
    if (!requestListRID) {
        throw new Error(`No request list resource found for: ${resourceId}`);
    }
    return requestListRID;
}
function getItemRID(resourceId) {
    const rid = RID.parse(resourceId);
    const itemRID = rid.findEntityType(RequestListEntityType.item);
    if (!itemRID) {
        throw new Error(`No request list resource found for: ${resourceId}`);
    }
    return itemRID;
}
export const capabilities = {
    [RequestListEntityType.requestlist]: requestListCapabilities,
    [RequestListEntityType.item]: itemCapabilities,
};
export function bulkRestoreAttachments(fileSourceStreamIdPairs) {
    return __awaiter(this, void 0, void 0, function* () {
        yield DefaultRequestListDataProvider.bulkRestoreTaskAttachments(fileSourceStreamIdPairs);
    });
}
export function bulkDeleteAttachments(fileSourceStreamIdPairs) {
    return __awaiter(this, void 0, void 0, function* () {
        yield DefaultRequestListDataProvider.bulkDeleteTaskAttachments(fileSourceStreamIdPairs);
    });
}
export function getAllTasks(userId, includedStates) {
    return __awaiter(this, void 0, void 0, function* () {
        const requestLists = yield DefaultRequestListDataProvider.getRequestListsByActorId(userId, includedStates);
        const tasks = yield Promise.all(requestLists.items.map((item) => __awaiter(this, void 0, void 0, function* () {
            const rlTasks = yield DefaultRequestListDataProvider.getTasks(item.requestListId, item.resourceId);
            return rlTasks.items;
        })));
        const allTasks = tasks.reduce((prev, curr) => prev.concat(curr), []);
        return allTasks;
    });
}
export function submitTask(item, message, extensionName) {
    return __awaiter(this, void 0, void 0, function* () {
        if (checkForPermission(item, PermissionPolicy.CanSendItemForReview)) {
            yield DefaultRequestListDataProvider.submitTask(item, { message });
            pendoSendTrackEvent(events.submitItemViaExtension, {
                extensionName: extensionName !== null && extensionName !== void 0 ? extensionName : '',
            });
            return true;
        }
        return false;
    });
}
export function addActorsToRequestList(requestListId, actorIds, notificationMessage, sendEmail, deferGrantPermissions) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield DefaultRequestListDataProvider.addRequestListActors(requestListId, {
            actorIds,
            notificationMessage,
            sendEmail,
            deferGrantPermissions,
        });
    });
}
export function addActorsToRequestListTask(requestListId, requestListTaskId, actorIds, notificationMessage, sendEmail) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield DefaultRequestListDataProvider.addRequestListTaskActors(requestListId, requestListTaskId, {
            actorIds,
            notificationMessage,
            sendEmail,
        });
    });
}
export function removeActorsFromRequestListTask(requestListTask, actorId, sendEmail) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield DefaultRequestListDataProvider.deleteRequestListTaskActor(requestListTask, actorId, sendEmail);
    });
}
//# sourceMappingURL=capabilities.js.map